exports = module.exports = require("../../../ext-web-comp-script/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".openCoinExchange-a9267ee5{box-shadow:0 3px 8px 2px rgba(1,1,1,0.2);width:376px;height:600px;position:fixed;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);z-index:999;border-radius:5px;font-family:MicrosoftYaHei;background-color:#fff}.openCoinExchange-a9267ee5 .openCoinExchangeClose-19ca9fa4{cursor:pointer;position:absolute;top:0;right:0;transform:translateX(50%) translateY(-50%);z-index:11}.openCoinExchange-a9267ee5 iframe{width:100%;height:100%;border:none}.jqClose-f55b402a{cursor:pointer}\n", ""]);

// Exports
exports.locals = {
	"openCoinExchange": "openCoinExchange-a9267ee5",
	"openCoinExchangeClose": "openCoinExchangeClose-19ca9fa4",
	"jqClose": "jqClose-f55b402a"
};